import * as z from "zod";

export const SquareSchema = z.string("Not a string").regex(/^[a-h][1-8]/, "Invalid square");

export const MoveSchema = z.discriminatedUnion("isPromotion", [
    z.object({
        isPromotion: z.literal(false),
        from: SquareSchema,
        to: SquareSchema,
    }),
    z.object({
        isPromotion: z.literal(true),
        promotion: z.string(),
        from: SquareSchema,
        to: SquareSchema,
    }),
]);

export const UserStatusSchema = z.union([z.literal("ready"), z.literal("not_ready")]);

export const UserColorSchema = z.union([z.literal("w"), z.literal("b")]);

export const UserSchema = z.object({
    userId: z.string("userId must be a string"),
    username: z.string("username must be a string"),
    picture: z.url("picture must be a valid url"),
    playerNumber: z
        .number("player number must be a number")
        .nonnegative("player number can not be negative"),
    userStatus: UserStatusSchema,
    color: UserColorSchema,
});

export const SavedLobbySchema = z.object({
    lobbyId: z.string(),
    username: z.string(),
    createdAt: z.number().nonnegative(),
});

export const GameSchema = z.object({
    fen: z.string(),
    isGameOver: z.boolean(),
    isCheck: z.boolean(),
    isCheckmate: z.boolean(),
    isStalemate: z.boolean(),
    moveNumber: z.number(),
});

export const CreateLobbyResponseSchema = z.object({
    lobbyId: z.string(),
});

export const JoinLobbyResponseSchema = z.object({
    newUser: UserSchema.omit({ color: true }),
    lobbyPollEndpoint: z.url(),
});

export const UserDDBSchema = UserSchema.extend({ connectionId: z.string() });

export const GameDDBSchema = GameSchema.extend({
    PK: z.string().startsWith("LOBBY#"),
    hostConnectionId: z.string(),
    TTL: z.string(),
    p1: UserSchema.extend({
        connectionId: z.string(),
    }),
    p2: UserSchema.extend({
        connectionId: z.string(),
    }),
});

export const MultiplayerStateSchema = z.object({
    isHost: z.boolean(),
    lobbyId: z.string(),
    waitingForPlayers: z.boolean(),
    playerColor: UserColorSchema,
    userId: z.string(),
    p1: UserSchema,
    p2: UserSchema,
    forfeit: z.discriminatedUnion("isForfeit", [
        z.object({
            isForfeit: z.literal(true),
            winner: UserDDBSchema,
        }),
        z.object({
            isForfeit: z.literal(false),
        }),
    ]),
    showUserNamePage: z.boolean(),
    playAgainRequest: z.object({
        sentRequest: z.boolean(),
        receivedRequest: z.boolean(),
    }),
    playAgainResponse: z.discriminatedUnion("receivedResponse", [
        z.object({
            sentResponse: z.boolean(),
            receivedResponse: z.literal(false),
        }),
        z.object({
            sentResponse: z.boolean(),
            receivedResponse: z.literal(true),
            response: z.union([z.literal("accept"), z.literal("deny")]),
        }),
    ]),
});
